export default __webpack_public_path__ + "static/media/check-icon.7f43f3e9.svg";